import { Organization } from '@ftr/contracts/api/organizations'
import { UserRole } from '@ftr/contracts/api/user'
import { AppPaths, OrganizationsPaths } from '@ftr/routing-paths'
import { SideNavGroup } from './side-nav-item'

export function getOrganizationAdminNavGroup(organization: Organization): SideNavGroup {
  if (organization.role !== UserRole.Admin) {
    return {}
  }
  return {
    title: 'Admin',
    items: [
      {
        type: 'LINK',
        icon: 'UsersLine',
        title: 'Users',
        path: [`/${AppPaths.Organizations}`, organization.id, OrganizationsPaths.Users],
      },
      {
        type: 'LINK',
        icon: 'Billing',
        title: 'Plans & Billing',
        path: [`/${AppPaths.Organizations}`, organization.id, OrganizationsPaths.Settings],
      },
      {
        type: 'LINK',
        icon: 'SettingsLine',
        title: 'Settings',
        path: [`/${AppPaths.Organizations}`, organization.id, OrganizationsPaths.Settings],
      },
    ],
  }
}
